import { AgentService } from './../services/agent.service';
import { FieldItem } from '../../models/common/field-item';
import { NavigationLink } from '../../models/common/navigation-link';
import { TabItem } from 'src/app/models/common/tab-items';
import { BaseComponent } from 'src/app/system-common/base/base.component';
import { Component, OnInit, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'sym-agent-document',
  templateUrl: './agent-document.component.html',
  styleUrls: ['./agent-document.component.scss'],
})
export class AgentDocumentComponent extends BaseComponent<AgentService> implements OnChanges {
  navigationLinkList: NavigationLink[];
  constructor(agentService: AgentService) {
    super(agentService);
    // console.log(this.service.responseIO);
  }
  ngOnInit() {
    this.setNavigationLinks();
  }
  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
  }

  private setNavigationLinks() {
    this.navigationLinkList = [];
    this.service.responseIO.data.DocumentCategoryList.filter((documentCategory) => {
      let nav = new NavigationLink();
      nav.link = documentCategory.docCategoryCd;
      nav.labelKey = this.service.getFieldLookupDesc(documentCategory, 'docCategoryCd');
      this.navigationLinkList.push(nav);
    });
  }

  /**
   * Calling this function seperately since only label is visible on screen and user tends to click on the Label rather
   * than the checkbox
   */
  public byPassOCrLabelClick(documentObj) {
    if (documentObj.disableOcrFl == undefined) documentObj.disableOcrFl = 'YES';
    else if (documentObj.disableOcrFl == 'YES') documentObj.disableOcrFl = 'NO';
    else if (documentObj.disableOcrFl == 'NO') documentObj.disableOcrFl = 'YES';
    this.disableOcrFl_change(undefined, documentObj);
  }

  protected disableOcrFl_change(item: FieldItem, model?) {
    if (item != undefined) model = item.model;
    if (model.disableOcrFl == 'YES' && model.DocumentImageList.length > 0) {
      let ans = confirm(this.service.getMultilingualLabel('ocrConfirmation'));
      if (ans) {
        model.DocumentImageList = [];
      } else {
        model.disableOcrFl = 'NO';
      }
    }
  }
}
